export const ACCOUNT_COPY = {
  pageTitle: "Account",
  pageSubtitle: "Sign-in details and closing your AxioHire account.",
  deletePageTitle: "Delete your account",
  deletePageSubtitle: "Request account deletion and review the seven-day recovery period.",
  deleteTitle: "Request account deletion",
  deleteBody:
    "After requesting deletion, you can log back in within 7 days to cancel the request and restore your account. After 7 days, your account data will be permanently deleted or anonymized. To use AxioHire again after that, you must create a new account and start over.",
  deleteCta: "Request account deletion",
  deleteConfirmTitle: "Request account deletion?",
  deleteConfirmCta: "Request deletion",
  deleteConfirmationLabel: "Type the confirmation below to continue",
  deleteConfirmationPrefix: "delete my account",
  deleteConfirmationSuffix: "to confirm.",
  deleteConfirmationCta: "Request deletion",
  deleteSuccessTitle: "Deletion scheduled",
  deleteSuccessBody:
    "You have been signed out. Log back in within 7 days to cancel deletion and restore your account. After that, deletion is permanent and requires a new account.",
  deleteRecoveryTitle: "Account restored",
  deleteRecoveryBody: "Your deletion request was cancelled and your account has been restored.",
} as const;

export function deleteAccountConfirmation(email: string): string {
  return `${ACCOUNT_COPY.deleteConfirmationPrefix} ${email}`;
}

export const PASSWORD_RESET_COPY = {
  forgotTitle: "Forgot password",
  forgotSubtitle: "Enter your account email and we will send a secure reset link when available.",
  forgotCta: "Send reset link",
  forgotSentTitle: "Check your email",
  forgotSentBody:
    "If this email uses an AxioHire password, a secure reset link will arrive shortly. Accounts that use Google should continue with Google sign-in.",
  forgotLink: "Forgot password?",
  resetTitle: "Set a new password",
  resetSubtitle: "Choose at least 8 characters with a letter and a number.",
  resetValidation: "Use at least 8 characters with a letter and a number.",
  resetCta: "Update password",
  resetMissingToken: "This reset link is missing or incomplete. Request a new one from the login page.",
  resetSuccessTitle: "Password updated",
  resetSuccessBody: "Sign in with your new password.",
  backToLogin: "Back to sign in",
} as const;

export const REGISTRATION_PASSWORD_COPY = {
  passwordLabel: "Password",
  confirmPasswordLabel: "Confirm password",
  confirmationError: "Passwords do not match",
} as const;

export const PASSWORD_MIN_LENGTH = 8;

export function validateResetPassword(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) return PASSWORD_RESET_COPY.resetValidation;
  if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
    return PASSWORD_RESET_COPY.resetValidation;
  }
  return null;
}

export function validatePasswordConfirmation(password: string, confirmation: string): string | null {
  return password === confirmation ? null : REGISTRATION_PASSWORD_COPY.confirmationError;
}
